import { TopicsService } from "@/services/CoachingServices";
import { mapGetters } from "vuex";

export default {
  props: {
    topicIds: {
      type: Array,
      default: () => null,
    },

    loadPrivateOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      topics: [],
      selectedTopicId: null,
    };
  },

  computed: {
    ...mapGetters(["getUserId"]),

    userId() {
      return this.getUserId ? `${this.getUserId}` : null;
    },

    selectedTopic() {
      return this.topics.find((t) => t.id === this.selectedTopicId) || null;
    },
  },

  watch: {
    topicIds: {
      immediate: true,
      async handler() {
        await this.loadTopics();

        if (this.topics.length === 0) return [];

        const initialTopicId = this.$route.query["topicId"] || null;
        if (
          this.selectedTopicId &&
          this.topics.find((t) => t.id === this.selectedTopicId)
        ) {
          this.handleSelectTopic(this.selectedTopicId);
        } else if (
          initialTopicId &&
          this.topics.find((t) => t.id === initialTopicId)
        ) {
          this.handleSelectTopic(initialTopicId);
        } else if (this.topics.length > 0) {
          this.handleSelectTopic(this.topics[0].id);
        }
      },
    },
  },

  methods: {
    async loadTopics() {
      try {
        let result;
        if (this.topicIds) {
          // If specific topic IDs are provided, load only those
          result = await TopicsService.getTopicsByIds(this.topicIds);
        } else if (this.userId) {
          if (this.loadPrivateOnly) {
            // Load only private topics
            result = await TopicsService.getUserTopics(this.userId);
          } else {
            // Load both public and private topics
            result = await TopicsService.getPublicAndUserTopics(this.userId);
          }
        } else {
          // Fallback to all public topics if no userId
          result = await TopicsService.getPublicTopics();
        }

        // Ensure we always work with an array
        this.topics = Array.isArray(result) ? result : result.topics || [];

        return this.topics;
      } catch (error) {
        console.error("Error loading topics:", error);
        this.$buefy.toast.open({
          message: "Failed to load topics",
          type: "is-danger",
        });
        this.topics = [];
        return [];
      }
    },

    handleSelectTopic(topicId) {
      this.selectedTopicId = topicId;
      this.$emit("topic-selected", topicId);
    },

    clearTopicSelection() {
      this.selectedTopicId = null;
    },
  },
};
